import { render, staticRenderFns } from "./AgeToggle.vue?vue&type=template&id=236ec9b9&scoped=true"
import script from "./AgeToggle.vue?vue&type=script&lang=js"
export * from "./AgeToggle.vue?vue&type=script&lang=js"
import style0 from "./AgeToggle.vue?vue&type=style&index=0&id=236ec9b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ec9b9",
  null
  
)

export default component.exports